import * as VeeValidate from "vee-validate";
import GlobalComponents from "./globalComponents";
import SideBar from "../components/black_dashboard_pro/SidebarPlugin";
// import GlobalDirectives from "./globalDirectives";
// import Notifications from '../components/black_dashboard_pro/NotificationPlugin';
// element ui language configuration


export default {
  install(Vue: any) {
    Vue.use(GlobalComponents);
    // Vue.use(GlobalDirectives);
    Vue.use(SideBar);
    // Vue.use(Notifications);
    Vue.use(VeeValidate, { fieldsBagName: "veeFields" });
  }
};
